import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Gfooter from "../Component/Gfooter";
import axios from "axios";

function Project1() {
  const { id } = useParams(); // yaha se job_id milega
  const [JobDisc, setJobDisc] = useState([]);

useEffect(() => {
  const fetchData = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/opening_list"
      );

      if (res.data.status && res.data.success === "1") {
        if (id) {
          // ✅ Type-safe comparison
          const filtered = res.data.data.filter(
            (item) => String(item.job_id) === String(id)
          );
          setJobDisc(filtered);
        } else {
          setJobDisc(res.data.data);
        }
      } else {
        setJobDisc([]);
      }
    } catch (err) {
      console.error("Error fetching job data:", err);
    }
  };

  fetchData();
}, [id]);


  return (
    <>
      <div>
        {JobDisc.map((Data) => (
          <div key={Data.job_id}>
            {/* Banner */}
            <div className="container-fluid project-bg">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <img
                  src={`https://cyberathon.com/NLF/${Data.job_banner}`}
                  alt="Job Banner"
                />
              </div>
            </div>

            {/* Job Details */}
            <div className="container-fluid job-details">
              <div className="row">
                <div className="col-lg-12 col-md-10 col-sm-12">
                  <h1 className="job-project-heading">
                    <strong>{Data.job_title}</strong>
                  </h1>
                </div>
              </div>

              <div className="max-w-1200 mx-auto">
                <div className="row no-gutters justify-content-center">
                  {/* Job Description */}
                  <div className="col-lg-7 col-sm-12 pr-50 mb-5">
                    <div className="job-description-container ql-editor">
                      <h2>Requirements:</h2>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: Data.job_description,
                        }}
                      />
                    </div>
                  </div>

                  {/* Apply Button */}
                  <div className="col-lg-3 col-sm-12">
                    <div className="sticky-job">
                      <div className="btn-container col-md-9 col-sm-12">
                        <button className="btn btn-info" id="apply-job">
                          <Link to="/form">
                            Apply for this job{" "}
                            <span className="arrow-icon">
                              <i className="fa-solid fa-arrow-right-long" />
                            </span>
                          </Link>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Footer */}
        <Gfooter />
      </div>
    </>
  );
}

export default Project1;
